export const removeLayer = (element: HTMLElement) => {
  const impressionTrackerVisualizingLayer = element.querySelector('#impressionTrackerVisualizingLayer')
  impressionTrackerVisualizingLayer?.remove()
}

export const addColoredLayer = (element: HTMLElement, color: string) => {
  let impressionTrackerVisualizingLayer = element.querySelector<HTMLElement>('#impressionTrackerVisualizingLayer')

  if (!impressionTrackerVisualizingLayer) {
    impressionTrackerVisualizingLayer = document.createElement('div')
    impressionTrackerVisualizingLayer.id = 'impressionTrackerVisualizingLayer'
  }

  impressionTrackerVisualizingLayer.style.backgroundColor = color
  impressionTrackerVisualizingLayer.style.position = 'absolute'
  impressionTrackerVisualizingLayer.style.top = element.offsetTop + 'px'
  impressionTrackerVisualizingLayer.style.left = element.offsetLeft + 'px'
  impressionTrackerVisualizingLayer.style.width = element.offsetWidth + 'px'
  impressionTrackerVisualizingLayer.style.height = element.offsetHeight + 'px'
  impressionTrackerVisualizingLayer.style.pointerEvents = 'none'

  element.appendChild(impressionTrackerVisualizingLayer)
}
